/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Badge from '@material-ui/core/Badge';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import Collapse from '@material-ui/core/Collapse';

import { isSecondLevelSelected, getMenu } from '../utils/sidebarUtils'

const drawerWidth = 220;

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(8),
  },
  appBarSpacer: theme.mixins.toolbar,
  selectedMenuItem: {
    backgroundColor: theme.palette.action.hover
  },
  menuItem: {
    textTransform: 'uppercase'
  }
}));

const SidebarView = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [menuItems, setMenuItems] = useState([]);

  const [selectedMenuItem, setSelectedMenuItem] = useState({
    selected: {
      toplevel: props.toplevel,
      secondlevel: props.secondlevel
    },
    previous: null
  })

  const [exit, setExit] = useState(false); /* eslint-disable-line */

  useEffect( () => {
    setMenuItems(getMenu(props.orgId, props.settings));
  }, [props.orgId])

  useEffect( () => {
    setSelectedMenuItem({
      selected: {
        toplevel: props.toplevel,
        secondlevel: props.secondlevel
      },
      previous: selectedMenuItem.previous
    })
  }, [props.toplevel, props.secondlevel])

  const handleDrawerOpen = () => {
    setSelectedMenuItem({
      selected: selectedMenuItem.previous,
      previous: null
    })
    setOpen(true);
  };

  const handleDrawerClose = () => {
    handleMenuSelect("")
    setOpen(false);
  };

  const handleDrawerToggle = () => {
    if (open) {
      handleDrawerClose()
    } else {
      handleDrawerOpen()
    }
  }

  const handleMenuSelect = (menuType) => {
    if (open === false){
      setOpen(true)
    }
    if (menuType === selectedMenuItem.selected.toplevel) {
      menuType = ""
    }
    setSelectedMenuItem({
      selected: {
        toplevel: menuType,
        secondlevel: selectedMenuItem.selected.secondlevel
      },
      previous: selectedMenuItem.selected
    })
  }

  const handleMenuNavigate = (menuType, childMenuType) => {
    props.dispatch({
      type: 'PAGE',
      payload: {
        orgId: props.orgId,
        toplevel: menuType,
        secondlevel: childMenuType,
      }
    });
  }

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <div className={classes.appBarSpacer} />
      <List>
        <ListItem
          key='menu-item-drawer'
          button
          onMouseOver={()=>setExit(true)}
          onClick={handleDrawerToggle}
        >
          <ListItemIcon>
            { open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </ListItemIcon>
        </ListItem>

        {menuItems.map(menuItem => (
          <div key={`menu-item-${menuItem.type}`}>
            <ListItem
              button
              data-cy={`${menuItem.type}`} // for selecting with cypress
              onClick={() => handleMenuSelect(menuItem.type)}
            >
              <ListItemIcon>
                <Icon className={menuItem.icon} style={{width:'100%'}} />
              </ListItemIcon>
              <ListItemText className={classes.menuItem} primary={menuItem.title} secondary={menuItem.subtitle} />
              {menuItem.badge && <Badge style={{ marginRight: 10 }} badgeContent={menuItem.badge} color="primary" />}
            </ListItem>
            <Collapse in={selectedMenuItem.selected.toplevel === menuItem.type} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItem.children.map(childMenuItem => (
                  <ListItem
                    button
                    data-cy={`${childMenuItem.type}`} // for selecting with cypress
                    data-license={`${menuItem.type}`} // for selecting in license cypress test
                    key={`menu-item-${childMenuItem.type}`}
                    className={
                      isSecondLevelSelected(childMenuItem, selectedMenuItem.selected.secondlevel) ? classes.selectedMenuItem : '' 
                    }
                    onClick={() => handleMenuNavigate(menuItem.type, childMenuItem.type)}
                  >
                    <ListItemIcon />
                    <Badge badgeContent={childMenuItem.badge} color="primary">
                      <ListItemText primaryTypographyProps={{'variant':'overline'}} primary={childMenuItem.title} />
                    </Badge>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </div>
        ))}
      </List>
    </Drawer>
  );
}


const mapStateToProps = (state) => {
  return {
    settings: state.session.settings
  };
};
export default connect(mapStateToProps)(SidebarView);
